// ShapeCheckbox.jsx
import { Check, X } from "lucide-react";
import React from "react";

const ShapeCheckbox = ({
  id,
  checked,
  onChange,
  width,
  height,
  borderColor,
  borderRadius,
  backgroundColor,
  shapeType,
  shapeTypeColor,
}) => {
  const effectiveWidth =
    typeof width === "number" && !Number.isNaN(width) ? width : 48;
  const effectiveHeight =
    typeof height === "number" && !Number.isNaN(height) ? height : 48;
  const renderShape = () => {
    if (!checked) return null;
    const size = Math.min(effectiveWidth, effectiveHeight) - 20;

    switch (shapeType) {
      case "tick":
        return <Check size={size} color={shapeTypeColor} />;
      case "cross":
        return <X size={size} color={shapeTypeColor} />;
      case "square":
        return (
          <div
            style={{
              width: size + 16,
              height: size + 15,
              backgroundColor: "transparent",
            }}
          />
        );
      case "circle":
        return (
          <div
            style={{
              width: size,
              height: size,
              borderRadius: "50%",
              backgroundColor: shapeTypeColor,
            }}
          />
        );
      default:
        return null;
    }
  };
  console.log(shapeType, width, height, "check values");

  return (
    <div
      className="w-full h-full flex items-center justify-center rounded-lg bg-transparent border-2 border-transparent p-2"
      style={{ width, height }}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="sr-only"
        id={`checkbox-${id}`}
      />

      <label
        htmlFor={`checkbox-${id}`}
        style={{
          width: "90%",
          height: "90%",
          backgroundColor: checked ? backgroundColor : "",
          border: `2px solid ${borderColor || "#000000"}`,
          borderRadius: borderRadius,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          boxSizing: "border-box",
        }}
      >
        {renderShape()}
      </label>
    </div>
  );
};

export default ShapeCheckbox;
